<script setup lang="ts">
import { useDeviceState } from "@/stores/DeviceState";
import DRDropdownItem from "@/components/UI/DRDropdownItem.vue";
import { useDownloadAllBranches } from "./downloadFile";

const props = defineProps<{
  drawingId?: number;
  fileName?: string;
}>();

const deviceState = useDeviceState();
const { mutateAsync, isLoading } = useDownloadAllBranches();

async function downloadAll() {
  if (!props.drawingId || !props.fileName) return;
  await mutateAsync(props.fileName, props.drawingId);
}
</script>

<template>
  <DRDropdownItem
    :disabled="!drawingId || !fileName || !deviceState.isOnline"
    :loading="isLoading"
    @select="downloadAll()"
    icon="bi-file-earmark-zip"
    :label="$t('drawings.download.allBranches')"
  />
</template>
